'use client';

import type { FC } from 'react';
import { Link } from '@/react/components/core-ui/Link';
import { msg } from '@/services/isomorphic/I18NService';
import { useLogout } from '@/react/hooks/useLogout';
import { Icon, IconTypes, IconSizeProp } from '@/react/components/core-ui/Icon';
import { useDrawerActions } from '@/react/components/core-ui/Drawer/hooks';
import { MobileNavItem } from '../../MobileNavItem';

import S from '../../../styles.base.module.scss';
import { account_authenticated_logout } from "@/lang/__generated__/ahnu/account_authenticated_logout";

interface ILogoutUtilityLinkProps {
  /** The icon type string matching an IconTypes enum value. */
  icon: string;
}

/**
 * Logout utility link for the mobile navigation drawer.
 * Only rendered when the user is authenticated.
 */
export const LogoutUtilityLink: FC<ILogoutUtilityLinkProps> = ({ icon }) => {
  const { isLoggedIn, logOut } = useLogout();
  const { closeAllDrawers } = useDrawerActions();

  if (!isLoggedIn) return null;

  const logoutLabel = msg(account_authenticated_logout);
  const logoutIcon = icon as IconTypes;

  return (
    <MobileNavItem>
      <span className={S.navLink}>
        <Link className={S.utilityLink} href="/" onClick={closeAllDrawers}>
          <button type="button" onClick={logOut} aria-label={logoutLabel}>
            <span className={S.labelContainer}>
              <Icon
                className={S.navLinkIcon}
                icon={logoutIcon}
                size={IconSizeProp.SizeSM}
              />
              {logoutLabel}
            </span>
          </button>
        </Link>
      </span>
    </MobileNavItem>
  );
};
